import React from 'react';
import * as scriptUtils from './utils/scriptUtils';
import * as loggingUtils from './utils/loggingUtils';
import * as encryptUtils from './encryptDecryptUtils';
import { useState } from "react";
import { useNavigate } from "react-router-dom";

function ListedNFT(props) {
  let [isExpanded, setIsExpanded] = useState(false);
  let [listingPrice, setListingPrice] = useState(0);
  let listedNFT = props.listedNFT;
  let heldNFTAnalog = null;
  let ind = props.ind;
  let ethToWeiConversion = 1000000000000000000;
  const navigate = useNavigate();
  for(let i = 0; i < props.heldNFTs.length; i++) {
    if(props.heldNFTs[i].authUUID === listedNFT.authUUID) {
      heldNFTAnalog = props.heldNFTs[i];
      break;
    }
  }

  function onChangePrice(e) {
    setListingPrice(parseFloat(e.target.value));
  }

  async function editPriceItem() {
    if(listingPrice < 0) {
      return;
    }
    props.setTransactionStatus("Pending");
    let didApprove = await encryptUtils.editPriceNFT(
      props.account.address,
      listedNFT.marketItemId,
      listedNFT.protocol,
      listingPrice*ethToWeiConversion
    );
    if(didApprove) {
      loggingUtils.logEvent(
        props.account.address,
        'my_nfts',
        'my_nfts_edit_price_item',
        'info',
        "https://the402.xyz",
        {
          item: listedNFT
        },
      );
    } else {
      props.setTransactionStatus("None");
    }
  }

  async function delistItem() {
    props.setTransactionStatus("Pending");
    let didApprove = await encryptUtils.delistNFT(
      props.account.address,
      listedNFT.marketItemId,
      listedNFT.protocol
    );
    if(didApprove) {
      loggingUtils.logEvent(
        props.account.address,
        'my_nfts',
        'my_nfts_delist_item',
        'info',
        "https://the402.xyz",
        {
          item: listedNFT
        },
      );
    } else {
      props.setTransactionStatus("None");
    }
  }

  function redirectToDedicatedPage() {
    navigate("/media/" + listedNFT.authUUID + "?protocol=" + listedNFT.protocol);
  }

  return (
    <div>
      <div className="w-80 h-112 mx-4 bg-white dark:bg-custom-black border-solid border dark:border-zinc-800 rounded-md" key={ind}>
        <div
          className="flex items-center justify-center h-80 rounded-t-md bg-custom-gray"
          onClick={redirectToDedicatedPage}
        >
          <img className="object-cover h-80 w-80 cursor-pointer" src={heldNFTAnalog.imagePinata} alt="PPV NFT" />
        </div>
        <div className="flex items-center h-16 justify-around">
          <div className="flex-col w-32 whitespace-nowrap overflow-hidden text-ellipsis">
            <div className="flex items-center">
              <img className="h-10 w-10" src={scriptUtils.getProfileImage(props.account.address)} alt="NFT address" />
              <div className="ml-2 flex-col">
                <div className="text-sm flex items-center text-black dark:text-white">
                  {heldNFTAnalog.name.replaceAll("_", " ")}
                </div>
                <div className = "text-sm flex items-center text-gray-500 dark:text-gray-400">
                  {props.account.address.substring(0, 5) + "..." + props.account.address.substring(props.account.address.length - 5)}
                </div>
              </div>
            </div>
          </div>
          <div className="flex items-center justify-center cursor-pointer w-20 h-8 bg-zinc-400 dark:bg-zinc-600 rounded-2xl" onClick={() => setIsExpanded(!isExpanded)}>
            <div className="text-white dark:text-white text-sm">
              {
                !isExpanded
                  ?
                "Edit Price"
                  :
                "Cancel"
              }
            </div>
          </div>
          <div className="flex items-center justify-center cursor-pointer w-20 h-8 bg-custom-black dark:bg-white rounded-2xl border-solid border border-gray-400" onClick={
            async () => await delistItem()
          }>
            <div className="text-white dark:text-black text-sm">
              Unlist
            </div>
          </div>
        </div>
        <div className="flex flex-col w-80 border-t dark:border-zinc-800">
          <div className="flex space-between w-full">
            <div className="flex w-full">
              <div className="flex items-center mt-2 px-4 text-black dark:text-white text-sm h-8">
                Editions Listed:
                <div className = "flex items-center ml-2 mr-4 text-black dark:text-white text-sm font-bold">
                  {listedNFT.amount}
                </div>
              </div>
              <div className="flex items-center mt-2 px-4 text-black dark:text-white text-sm h-8">
                Price:
                {
                  isExpanded
                    ?
                  <input className = "px-4 ml-2 bg-zinc-300 dark:bg-zinc-600 w-24 h-6 rounded-md" type="number" name="price" min="0" onChange={e => onChangePrice(e)} />
                    :
                  <div className = "flex items-center ml-2 mr-4 text-black dark:text-white text-sm font-bold">
                    {listedNFT.price / ethToWeiConversion}
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      {
        isExpanded
          ?
        <div className = "mx-4 flex w-80 items-center rounded-lg bg-black dark:bg-white text-white dark:text-black h-16 justify-center cursor-pointer font-semibold" onClick={
          async () => await editPriceItem()
        }>
          CONFIRM PRICE
        </div>
          :
        null
      }
    </div>
  );
}

export default ListedNFT;
